export const recaptchaActions = {
  RETARGETING: 'retargeting_collect',
  APPOINTMENT: 'APPOINTMENT',
};
